import * as types from "../../constants";
import { deleteAllPatientsFromInvestigation, getAllPatientsInvestigation, saveListPatients, savePatient } from "../../db";
import {
    fetchInvestigations as fetchInvestigationsService
} from "../../services";
import { createUpdateBillingInfoService, getBillablesByCoverageService, getBillablesService, updateBillablesService } from "../../services/billing";
import { saveAestheticsService } from "../../services/aesthetics";
import { updateAgendaConfigService } from "../../services/agenda";
import { decryptSinglePatientData, getLastSyncEventId } from "../../utils";
import { fetchPatientsAction, incrementalSyncPatientsAction } from "./patientsActions";

export function fetchInvestigations() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_INVESTIGATIONS_LOADING });

    return fetchInvestigationsService()
      .then(async (response) => {
        
        dispatch({
            type: types.FETCH_INVESTIGATIONS_SUCCESS,
            investigations: response.investigations,
        });

        const pendingApprovalInvestigation = response.investigations.find((investigation) => investigation.shareStatus === 0);

        if(!pendingApprovalInvestigation){
            if(response.investigations.length === 1){
                dispatch(selectInvestigation(response.investigations[0].uuid));
            }
            else if(localStorage.getItem("uuidInvestigation")){
                const investigation = response.investigations.find((investigation) => investigation.uuid === localStorage.getItem("uuidInvestigation"));
                if(investigation){
                    dispatch(selectInvestigation(investigation.uuid));
                }
            }
        }
        
        
      })
      .catch((error) => {
        // SHER-217 — pass the error payload through so the reducer (and any caller
        // reading state.investigations.error) can surface "Researcher not found" /
        // 401 / etc. instead of silently leaving the SPA on "Downloading data".
        // Normalise so callers always have { status, errorMessage }.
        const normalised = (error && typeof error === "object")
            ? {
                status: error.status ?? error.response?.status ?? error.response?.data?.status ?? 0,
                errorMessage: error.errorMessage
                    ?? error.response?.data?.errorMessage
                    ?? error.message
                    ?? "fetchInvestigations failed",
            }
            : { status: 0, errorMessage: String(error || "fetchInvestigations failed") };
        dispatch({ type: types.FETCH_INVESTIGATIONS_ERROR, error: normalised });
        throw error;
      });
  };
}

export function createUpdateBillingInfoAction(uuidInvestigation, billingInfo) {
    return async (dispatch) => {
      dispatch({ type: types.FETCH_INVESTIGATIONS_LOADING });
  
      return createUpdateBillingInfoService(uuidInvestigation, billingInfo)
        .then((response) => {
          dispatch({
            type: types.UPDATE_BILLING_INFO_SUCCESS,
            billingInfo: response.billingInfo,
          });
        })
        .catch((error) => {
          dispatch({ type: types.UPDATE_BILLING_INFO_ERROR });
          throw error;
        });
    };
}

export function saveAestheticsAction(uuidInvestigation, aesthetics) {
    return async (dispatch) => {
        dispatch({ type: types.FETCH_INVESTIGATIONS_LOADING });

        return saveAestheticsService(uuidInvestigation, aesthetics)
            .then(() => {
                dispatch({
                    type: types.UPDATE_AESTHETICS_SUCCESS,
                    aesthetics: { params: aesthetics },
                });
            })
            .catch((error) => {
                dispatch({ type: types.UPDATE_AESTHETICS_ERROR });
                throw error;
            });
    };
}

export function updateAgendaConfigAction(uuidInvestigation, agendaConfigParams) {
    return async (dispatch) => {
        dispatch({ type: types.FETCH_INVESTIGATIONS_LOADING });

        return updateAgendaConfigService(uuidInvestigation, agendaConfigParams)
            .then((response) => {
                dispatch({
                    type: types.UPDATE_AGENDA_CONFIG_SUCCESS,
                    outpatientsInfo: response.agendaConfig.params,
                });
            })
            .catch((error) => {
                dispatch({ type: types.UPDATE_AGENDA_CONFIG_ERROR });
                throw error;
            });
    };
}

export function updateBillables(uuidInvestigation, idBillingInfo, billables) {
    return async (dispatch) => {
      dispatch({ type: types.FETCH_INVESTIGATIONS_LOADING });
  
      return updateBillablesService(uuidInvestigation, idBillingInfo, billables)
        .then((response) => {
          dispatch({
            type: types.UPDATE_BILLABLES_SUCCESS,
            billables: response.billables,
          });
        })
        .catch((error) => {
          dispatch({ type: types.UPDATE_BILLABLES_ERROR });
          throw error;
        });
    };
}

export function getBillablesAction(uuidInvestigation, idBillingInfo, idCoverage){
    return async (dispatch) => {
        dispatch({ type: types.FETCH_BILLING_LOADING });
        return getBillablesByCoverageService(uuidInvestigation, idBillingInfo, idCoverage)
            .then((response) => {
                dispatch({
                    type: types.GET_BILLABLES_SUCCESS,
                    billables: response.billables,
                });
            })
            .catch((error) => {
                dispatch({ type: types.GET_BILLABLES_ERROR });
                throw error;
            });
    };
}
export function selectInvestigation(uuidInvestigation) {
    return async (dispatch, getState) => {
        dispatch({
            type: types.SELECT_INVESTIGATION,
            selectedInvestigation: uuidInvestigation
        });
        const currentState = getState().investigations;
        const investigation = currentState.data.find((inv) => inv.uuid === uuidInvestigation);
        if (!investigation) return;

        const lastEventId = getLastSyncEventId(uuidInvestigation);
        if (lastEventId != null) {
            const localPatients = await getAllPatientsInvestigation(uuidInvestigation);
            dispatch({ type: types.INITIALIZE_PATIENTS, payload: { uuidInvestigation, patients: localPatients } });
            dispatch(incrementalSyncPatientsAction(uuidInvestigation, true));
        } else {
            dispatch(fetchPatientsAction(investigation.uuid));
        }
    };
}

export function initializeBilling(newState) {
    return async (dispatch) => {
      dispatch({ 
            type: types.INITIALIZE_INVESTIGATIONS,
            newState:newState
      });
    };
}